const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/paywall_tax_settings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/paywall_tax_settings")({
  beforeLoad: ({
    context
  }) => {
    const currentCommunity = context.punditUserContext?.currentCommunity;
    const isPaywallTaxAvailable = currentCommunity?.policies?.is_paywall_tax_available || !currentCommunity?.payment_processor;
    if (!isPaywallTaxAvailable) redirect({
      to: "/settings/paywalls",
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});